<template>
  <cv-content id="main-content" style="max-width: 1300px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal"
            style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="4">
          <data-valida etichetta="Data di Registrazione"
                       v-model="modello.dta_registrazione"
                       messaggio_non_valido="Data di registrazione non valida" />
        </cv-column>
        <cv-column :sm="4" :md="4" :lg="4">
          <data-valida etichetta="Data di Utilizzo Materiale"
                       v-model="modello.dta_utilizzo"
                       messaggio_non_valido="Data di utilizzo non valida" />
        </cv-column>

        <cv-column :sm="4" :md="4" :lg="8">
          <cv-combo-box label="Seleziona una macchina"
                        title="Utilizzato su" :auto-filter="true"
                        v-model="modello_macchine"
                        value="FIAT"
                        :options="macchine"></cv-combo-box>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-data-table :columns="colonne"
                         :data="righe"
                         helper-text="Materiali" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-area
              label="Note"
              value=""></cv-text-area>
        </cv-column>
      </cv-row>
    </cv-grid>

    <hr/>
    <Bottoniera testo_nuovo="Nuova Utilizzo"
                testo_salva="Salva Utilizzo"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";

export default {
  name: "UtilizzoMateriali",
  components: { Bottoniera },
  data: function() {
    return {
      modello: {
        dta_registrazione: "10/08/2000",
        dta_utilizzo: "11/08/2020"
      },
      modello_macchine: "FIAT",
      colonne: [
        "Descrizione",
        "Unità di Misura",
        "Quantità"
      ],
      righe: [
        [
          "Olio",
          "Kg",
          "20"
        ],
        [
          "Bulloni",
          "Nr",
          "3"
        ],
      ],
      macchine: [
        {
          value: "1",
          label: "FIAT",
          name: "1"
        },
        {
          value: "2",
          label: "FENDT",
          name: "2"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>